(function (Drupal, once) {
  Drupal.behaviors.partnersCarousel = {
    selector: '.partners-splide',
    splideInstances: new Map(),
    resizeHandlerBound: false,

    getPerPageForViewport: function() {
      const width = window.innerWidth;
      if (width >= 1440) return 8;
      if (width >= 900) return 6;
      if (width >= 750) return 5;
      if (width >= 620) return 4;
      if (width >= 400) return 3;
      return 2;
    },

    shouldBuildCarousel: function(childCount, perPage) {
      return childCount > perPage;
    },

    getSlideCount: function(carousel) {
      return carousel.querySelectorAll('.splide__slide:not(.splide__slide--clone)').length;
    },

    buildCarousel: function(carousel) {
      carousel.classList.remove('splide--no-carousel');
      const splide = new Splide(carousel, {
        perPage: 8,
        type: 'loop',
        autoplay: true,
        drag: false,
        gap: '2.8rem',
        breakpoints: {
          1440: {
            perPage: 6,
          },
          900: {
            perPage: 5,
          },
          750: {
            perPage: 4,
          },
          620: {
            perPage: 3,
          },
          400: {
            perPage: 2,
          },
        }
      });
      splide.mount();
      this.splideInstances.set(carousel, splide);
    },

    destroyCarousel: function(carousel, splide) {
      carousel.classList.add('splide--no-carousel');
      splide.destroy(true);
      this.splideInstances.delete(carousel);
    },

    applyCarousel: function(carousel) {
      const childCount = this.getSlideCount(carousel);
      const perPage = this.getPerPageForViewport();
      const shouldBuild = this.shouldBuildCarousel(childCount, perPage);
      const existingSplide = this.splideInstances.get(carousel);

      if (shouldBuild && !existingSplide) {
        this.buildCarousel(carousel);
      } else if (!shouldBuild && existingSplide) {
        this.destroyCarousel(carousel, existingSplide);
      } else if (!shouldBuild && !existingSplide) {
        carousel.classList.add('splide--no-carousel');
      }
    },

    attach: function attach() {
      const carousels = once('partners-carousel-once', this.selector);

      if (carousels.length <= 0) {
        return;
      }

      carousels.forEach(carousel => {
        const childs = carousel.querySelectorAll('.splide__slide');
        if (childs.length > 1) {
          this.applyCarousel(carousel);
        }
      });

      if (!this.resizeHandlerBound) {
        const behavior = this;
        let resizeTimeout;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            document.querySelectorAll(behavior.selector).forEach(carousel => {
              behavior.applyCarousel(carousel);
            });
          }, 250);
        });
        this.resizeHandlerBound = true;
      }
    }
  }
})(Drupal, once);
